import script from "./PaymentRequired.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentRequired.vue?vue&type=script&setup=true&lang=js"

import "./PaymentRequired.vue?vue&type=style&index=0&id=fd534876&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd534876"]])

export default __exports__